import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const bannerStyle = {
  backgroundColor: "#c0392b",
  color: "#ffffff",
  textAlign: "center",
  fontSize: "16px",
  fontWeight: 600,
  position: "sticky",
  top: 0,
  zIndex: 1300,
};

const linkStyle = {
  color: "#ffffff",
  textDecoration: "underline",
  marginLeft: "8px",
};

const PasswordWarningBanner = () => {
  const [message, setMessage] = useState(
    () => localStorage.getItem("passwordWarning") || null
  );

  useEffect(() => {
    const sync = () => setMessage(localStorage.getItem("passwordWarning") || null);
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  if (!message) return null;

  return (
    <div className="passwordWarningBanner" style={bannerStyle} role="alert">
      Your password doesn't meet current security requirements. Please update it as soon as possible.
      <Link to="/profile" style={linkStyle}>
        Update password
      </Link>
    </div>
  );
};

export default PasswordWarningBanner;
